export const generateGridLayout = (number) => {
  if (number === 5) {
    return {
      lg: [50, 50, 33.33, 33.33, 33.33],
      md: [6, 6, 6, 6, 6],
      sm: [12, 12, 12, 12, 12],
      xs: [12, 12, 12, 12, 12],
      xxs: [12, 12, 12, 12, 12],
    };
  }
  if (number === 4) {
    return {
      lg: [50, 50, 50, 50],
      md: [6, 6, 6, 6],
      sm: [12, 12, 12, 12],
      xs: [12, 12, 12, 12],
      xxs: [12, 12, 12, 12],
    };
  }
  if (number === 3) {
    return {
      lg: [50, 50, 100],
      md: [6, 6, 6],
      sm: [12, 12, 12],
      xs: [12, 12, 12],
      xxs: [12, 12, 12],
    };
  }
  if (number === 2) {
    return {
      lg: [100, 100],
      md: [6, 6, 6],
      sm: [12, 12, 12],
      xs: [12, 12, 12],
      xxs: [12, 12, 12],
    };
  }
  if (number === 1) {
    return {
      lg: [100],
      md: [6, 6, 6],
      sm: [12, 12, 12],
      xs: [12, 12, 12],
      xxs: [12, 12, 12],
    };
  }
};

export const removeEmptyHTMLTags = (html) => {
  var doc = new DOMParser().parseFromString(html, "text/html");
  var elements = doc.body.querySelectorAll("*");

  for (var i = elements?.length - 1; i >= elements?.length - 4; i--) {
    var el = elements[i];
    if (el?.innerHTML === "") {
      el.parentNode.removeChild(el);
    }
  }

  return doc.body.innerHTML;
};

export const CheckMediaType = (url) => {
  if (!url) return null;
  if (Object.keys(url).length === 1) url = Object.values(url)[0];
  if (
    url.includes("mp4") ||
    url.includes("webm") ||
    url.includes("ogg") ||
    url.includes("mov")
  ) {
    return "video";
  }
  if (
    url.includes("jpg") ||
    url.includes("png") ||
    url.includes("jpeg") ||
    url.includes("gif")
  ) {
    return "image";
  }
  if (url?.includes("__blank")) return null;

  return "other";
};

export const checkIsIframeURL = (url) => {
  if (!url) return null;
  const urls = url?.map((item) => {
    if (item?.includes(".ajnavidya")) {
      return item;
    }
    return null;
  });
  return urls?.filter((item) => item !== null)[0];
};

export const AddEmbededVideo = (url) => {
  if (url?.includes("marketplace") || url?.includes("drive")) {
    return url;
  }
  if (url?.includes("__blank")) return null;
  const checkYoutubeBe = url.includes("youtu.be");
  if (checkYoutubeBe) {
    return `https://www.youtube.com/embed/${url.split("be/")[1]}`;
  }
  return url.includes("embed")
    ? url
    : `https://www.youtube.com/embed/${url.split("v=")[1]}`;
};

export const StringFormater = (string) => {
  return string?.replace("%20", " ");
};

export const generateNumberOfArray = (number) => {
  return [...Array(number).keys()];
};

export const isBlob = (value) => {
  if (value?.includes("blob")) {
    if (value?.includes(".mp4")) {
      return value.replace(".mp4", "");
    }
    if (value?.includes(".png")) {
      return value.replace(".png", "");
    }
  }
  return value;
};

export const getTime = (date) => {
  return new Date(date).toLocaleTimeString("en-US", {
    hour: "numeric",
    hour12: true,
    minute: "numeric",
  });
};

export const getSizeMedia = (data, type) => {
  const size = data?.size;
  var dimensions = new Image(data);

  const sizeInMb = size / 1000000;
  if (sizeInMb > 5 && type === "image") {
    return `Image size is too large. Please upload image less than 5MB`;
  }
  if (sizeInMb > 30 && type === "video") {
    return `Video size is too large. Please upload video less than 30MB`;
  }
  return null;
};

export const getHeightAndWidthFromDataUrl = (dataURL) =>
  new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      resolve({
        height: img.height,
        width: img.width,
      });
    };

    img.src = dataURL;
  });

export const StringToHTML = (str) => {
  const newLineRegex = /(\r\n|\n|\r)/gm;
  const newLine = "<br>";
  str = str?.replace(newLineRegex, newLine);
  return str;
};

export const driveLinksList = (urlArr) => {
  const driveLinks = urlArr?.filter((item) => item?.includes("drive"));
  return driveLinks;
};

export const getSearchParam = (param) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

export const hasSearchParam = (param) => {
  let urlParams = window.location.href;
  if (!urlParams?.includes("#?redirect=/")) return false;
  urlParams = urlParams.replace("#?redirect=/", "");
  return urlParams;
};
